import { useRef } from "react";
import { motion } from "framer-motion";
import NetworkGraphic from "@/components/NetworkGraphic";
import { PILLARS } from "@/data/content";

export default function Pillars() {
  const ref = useRef(null);

  return (
    <section
      id="pillars"
      ref={ref}
      data-testid="pillars-section"
      className="relative z-30 bg-[#070707]"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 md:grid-cols-2">
        {/* Sticky animated graphic */}
        <div className="relative hidden md:block">
          <div className="sticky top-0 h-screen overflow-hidden" data-testid="pillars-graphic">
            <NetworkGraphic />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-transparent to-[#070707]/40" />
          </div>
        </div>

        {/* Scrolling pillars */}
        <div className="px-6 py-20 md:px-14 md:py-0">
          <div className="flex items-center gap-4 pb-6 pt-6 text-xs uppercase tracking-[0.35em] text-[#7c7a72] md:pt-40">
            <span className="h-px w-10 bg-[#10b981]" />
            What I build with
          </div>
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-120px" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`pillar-${i}`}
              className="flex min-h-[70vh] flex-col justify-center border-t border-white/10 md:min-h-screen"
            >
              <div className="flex items-baseline gap-4">
                <span className="font-display text-3xl text-[#10b981]">{p.n}</span>
                <span className="text-[11px] uppercase tracking-[0.3em] text-[#7c7a72]">
                  {p.tag}
                </span>
              </div>
              <h3 className="mt-4 font-display text-5xl md:text-7xl leading-[0.95] text-[#f2f0e6]">
                {p.title}
              </h3>
              <p className="mt-6 max-w-md text-base md:text-lg leading-relaxed text-[#b9b6a8]">
                {p.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
